export const emptyOnboardingTitle = 'Manage your work in the field with Tasks';
export const emptyOnboardingSubtitle = 'Keep tabs on all aspects of the job, from start to finish.';
export const emptyOnboardingLink = 'https://help.fulcrumapp.com/en/articles/6061128-managing-the-task-backlog';
export enum createButtonLabel {
  record= 'Record',
  task= 'Task'
}
export const emptyFilteredTasksTitle = '0 results';
export const emptyFilteredTasksSubtitle = 'Use fewer filters or reset all filters.';
